// src/lib/workspace.client.ts — workspace-ul curent: harta selectată o singură dată,
// vizibilă în tot UI-ul (hartă, documente, registre, șabloane). Persistat în
// localStorage; deep link-urile `#/map?map=slug` îl suprascriu la încărcare (în shell).

import van from "vanjs-core"

export interface Workspace {
	slug: string // "" = niciun workspace ales
	name: string
}

const STORAGE_KEY = "urbanism_workspace"

function load_workspace(): Workspace {
	try {
		const raw = localStorage.getItem(STORAGE_KEY)
		if (raw) {
			const w = JSON.parse(raw) as Partial<Workspace>
			if (typeof w.slug === "string" && w.slug) {
				return { slug: w.slug, name: String(w.name || w.slug) }
			}
		}
	} catch {
		// localStorage indisponibil (ex. private mode) — pornim fără workspace
	}
	return { slug: "", name: "" }
}

export const workspace = van.state<Workspace>(load_workspace())

/**
 * Link MCP legat de o hartă (workspace): serverul primește harta din URL (?map=). Cu `token`
 * dat, e gata de conectat — clientul (ex. ChatGPT „No Auth") prezintă tokenul tot din URL.
 */
export function mcp_url(slug: string, token = ""): string {
	const base = `${location.origin}/mcp?map=${encodeURIComponent(slug)}`
	return token ? `${base}&token=${encodeURIComponent(token)}` : base
}

/** Link MCP pentru TOATĂ organizația (AI-ul alege harta per apel) — doar tokenul, fără hartă. */
export function mcp_url_org(token: string): string {
	return `${location.origin}/mcp?token=${encodeURIComponent(token)}`
}

/** Copiază în clipboard, cu fallback pe execCommand pentru contexte non-secure (http). */
export async function copy_to_clipboard(text: string): Promise<boolean> {
	try {
		await navigator.clipboard.writeText(text)
		return true
	} catch {
		try {
			const ta = document.createElement("textarea")
			ta.value = text
			ta.style.position = "fixed"
			ta.style.opacity = "0"
			document.body.appendChild(ta)
			ta.select()
			const ok = document.execCommand("copy")
			ta.remove()
			return ok
		} catch {
			return false
		}
	}
}

/** Setează workspace-ul global (slug gol = deselectare). Numele e opțional (implicit slug-ul). */
export function set_workspace(slug: string, name = "") {
	const w: Workspace = { slug, name: name || slug }
	if (workspace.val.slug === w.slug && workspace.val.name === w.name) {
		return
	}
	workspace.val = w
	try {
		if (slug) {
			localStorage.setItem(STORAGE_KEY, JSON.stringify(w))
		} else {
			localStorage.removeItem(STORAGE_KEY)
		}
	} catch {
		// persistența e best-effort
	}
}
